import { Theme, Tooltip } from '@livecontrol/core-ui';
import { Matrix } from '@livecontrol/scheduler/components';
import type { ReactElement } from 'react';
import styled from 'styled-components';

import H = Matrix.Grid.Header;

const TooltipContainer = styled(Tooltip)`
  &.tooltip {
    z-index: 1 !important;
  }

  .tooltip-inner {
    max-width: 140px;
  }
`;

interface Props {
  errors: boolean;
  roleContact: number;
  errorsMessages: string;
}

export const HeaderLocation = ({
  errors,
  roleContact,
  errorsMessages
}: Props): ReactElement => {
  const viewport = Theme.useViewport();

  return (
    <H style={{minWidth: 141, backgroundColor: 'white', padding: 0}}  className=' header text-center text-dark font-weight-bold' viewport={viewport}>
      {errors ? (
        <TooltipContainer
          show
          backgroundColor='#FF505F'
          tip={
            <div>
              <div className='font-weight-bold font-size-11px'>
                {roleContact === 5 && errorsMessages === 'itemDuplicated'
                  ? 'Priorities must be unique.'
                  : 'You must choose one contact.'}
              </div>
            </div>
          }
        >
          <div>Check to Assign</div>
        </TooltipContainer>
      ) : 
        'Check to Assign'
      }
    </H>
  );
};
